declare var require: any;

import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  OnDestroy,
  EventEmitter,
  Output,
} from '@angular/core'
import { Observable } from 'rxjs/Rx'
import {
  RIDE_TYPES,
  getOtpDisplayString,
  getPaymentDisplayText,
  getPaymentModeDisplayText,
  getPinLabel,
  getStartedEtaText,
  isDropPhase,
  isPickupPhaseStatus,
  isParcelOrderType,
} from '../shared/constants'
import { ImageViewService } from '../image-view.service'

@Component({
  selector: 'ride-details',
  template: require('./ride-details.component.html'),
})
export class RideDetailsComponent implements OnInit, OnChanges, OnDestroy {
  @Input('data') data: any;
  @Output() reload: EventEmitter<any> = new EventEmitter();
  private S3_URL_REGEX: RegExp
  private GCS_URL_REGEX: RegExp
  public name: string;
  public number: string;
  public avgRating: number;
  public vehicleModel: string;
  public vehicleNumber: string;
  public currentTime: Date = new Date();
  public updatedTime: Date = new Date();
  public lastUpdated = 0;
  public orderType: string;
  public profilePicUrl: string;
  public dropAddress: string;
  public pickupAddress: string;
  public status: string;
  public eta = 0;
  public dropOTP: number;
  public otp: number;
  public subscriber: any;
  public ownerName: string;
  public customerName: string;
  public rideOrOrder: string;
  public helpLineNumber: string;
  public locationDetailsExpanded = false;
  public OfferDetailsExpanded = false;
  public otpString: string;
  public pinLabel: string;
  public startedEtaText: string;
  public captainPhotoUrl: string;
  private currentProfilePictureUrl: string;
  public amount: number;
  private isImageLoading = false;
  public stauses = ['onTheWay', 'arrived', 'started'];
  public SOSImage: string = '../../../assets/img/SOS.svg';
  public bookForSomeoneElse: any;
  public subTotal: number;
  public offerApplied: boolean;
  public offerName: string;
  public offerCode: string;
  public droppedAt: string;
  public pickupName: string;
  public dropName: string;
  public mode: string;
  public paymentDisplayText: string;
  public paymentModeDisplayText: string;
  public paymentImage: string;
  modeImageMap: { [key: string]: string } = {
    'cash': require('../../assets/payments.svg'),
    'qrcode': require('../../assets/payments.svg'),
    'gpay': require('../../assets/gpay.svg'),
    'upi': require('../../assets/gpay.svg'),
    'rapido': require('../../assets/rapidowallet.svg'),
    'corporate': require('../../assets/rapidowallet.svg'),
    'amazonpay': require('../../assets/amazonpay.svg'),
    'paytm': require('../../assets/paytm.svg'),
    'lazypay': require('../../assets/lazypay.svg'),
    'simpl': require('../../assets/simpl.svg'),
  };
  constructor(private _imageViewService: ImageViewService) {
    this.S3_URL_REGEX = new RegExp(/(s3-|s3\.)?(.*)\.amazonaws\.com/)
    this.GCS_URL_REGEX = new RegExp(/(.*)\.storage\.googleapis\.com/)
   }

  ngOnInit() {
    this.subscriber = Observable.interval(500).subscribe(() => {
      this.currentTime = new Date();
      this.lastUpdated = this.currentTime.getMinutes() - this.updatedTime.getMinutes();
      this.lastUpdated = Math.abs(this.lastUpdated);
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.data && changes.data.currentValue) {
      const data = changes.data.currentValue;
      const riderObj = this.resolveRiderObj(data);
      if (!riderObj) {
        return;
      }

      this.name = riderObj.riderInfo.name;
      this.customerName = data.customerObj && data.customerObj.name;
      this.ownerName = RIDE_TYPES.includes(data.orderType) ? this.customerName : 'Captain';
      this.number = riderObj.riderInfo.mobile;
      const profilePicture = riderObj.riderInfo.profilePicture;
      this.captainPhotoUrl = profilePicture || '';
      if (profilePicture !== this.currentProfilePictureUrl) {
        this.currentProfilePictureUrl = profilePicture;
        this.profilePicUrl = null;
        this.isImageLoading = false;
      }
      this.setImageUrl(profilePicture);
      this.orderType = data.orderType;
      this.status = data.status;
      this.pinLabel = getPinLabel(data.orderType);
      this.startedEtaText = getStartedEtaText(data.orderType);
      this.vehicleNumber = riderObj.vehicleObj.number;
      this.vehicleModel = riderObj.vehicleObj.make;
      this.dropAddress = data.dropLocation && data.dropLocation.address;
      this.pickupAddress = data.pickupLocation && data.pickupLocation.address;
      this.pickupName = (data.pickupLocation && data.pickupLocation.name) || '';
      this.dropName = (data.dropLocation && data.dropLocation.name) || '';
      this.eta = data.riderLocation && data.riderLocation.eta || this.eta;
      this.updatedTime = new Date();
      this.avgRating = riderObj.avgRating != null ? riderObj.avgRating : null;
      this.dropOTP = data.dropOTP;
      this.otp = data.otp;
      document.title = this.customerName ? this.customerName + '\'s Rapido' : 'Rapido';
      this.helpLineNumber = data.helpLineNumber;
      this.bookForSomeoneElse = data.bookForSomeoneElse;
      this.otpString = getOtpDisplayString(data);
      this.amount = data.pricing && data.pricing.amount;
      this.subTotal = data.pricing && data.pricing.subTotal;
      this.offerApplied = data.pricing && data.pricing.offer && data.pricing.offer.applied;
      this.offerName = this.offerApplied ? data.pricing.offer.name : '';
      this.offerCode = this.offerApplied ? data.pricing.offer.code : '';
      this.droppedAt = data.droppedAt;
      this.mode = data.payment && data.payment.mode;
      this.paymentDisplayText = getPaymentDisplayText(
        data.payment,
        data.c2c || data.packageDelivery,
        data.orderType
      );
      this.paymentModeDisplayText = isParcelOrderType(data.orderType)
        ? getPaymentModeDisplayText(data.payment && data.payment.mode)
        : '';
    }
  }

  resolveRiderObj(data: any): any {
    if (data.riderObj) {
      const riderObj = data.riderObj;
      return {
        avgRating: riderObj.avgRating != null ? riderObj.avgRating : null,
        vehicleObj: riderObj.vehicleObj || {},
        riderInfo: riderObj.riderInfo || {
          name: riderObj.name || '',
          mobile: riderObj.mobile || '',
          profilePicture: riderObj.profilePicture || '',
        },
      };
    }

    if (data.captain) {
      const captain = data.captain;
      const vehicle = captain.vehicleObj || captain.vehicle || {};
      return {
        avgRating: captain.avgRating != null ? captain.avgRating : captain.rating,
        vehicleObj: {
          number: vehicle.number || captain.vehicleNumber || '',
          make: vehicle.make || captain.vehicleMake || '',
        },
        riderInfo: {
          name: captain.name || '',
          mobile: captain.mobile || captain.phone || '',
          profilePicture: captain.profilePicture || captain.profilePic || '',
        },
      };
    }

    return null;
  }

  isDirectProfileImageUrl(hostname: string) {
    return (
      this.isS3Url(hostname) ||
      this.isGCSUrl(hostname)
    );
  }

  isS3Url(hostname: string) {
    return this.S3_URL_REGEX.test(hostname);
  }

  isGCSUrl(hostname: string) {
    return this.GCS_URL_REGEX.test(hostname);
  }

  setImageUrl(url) {
    if (!url || this.isImageLoading) {
      return;
    }

    if (this.profilePicUrl) {
      return;
    }

    try {
      const { hostname, pathname, search } = new URL(url);
      if (this.isDirectProfileImageUrl(hostname)) {
        this.profilePicUrl = url;
      } else {
        this.isImageLoading = true;
        this._imageViewService.getPreSignedUrl(pathname, search).subscribe(
          (preSignedUrl) => {
            this.isImageLoading = false;
            this.profilePicUrl = preSignedUrl['url'];
          },
          () => {
            this.isImageLoading = false;
            this.profilePicUrl = url;
          }
        );
      }
    } catch (error) {
      this.profilePicUrl = url;
    }
  }

  toggleLocationExpansion() {
    this.locationDetailsExpanded = !this.locationDetailsExpanded;
    setTimeout(() => {
      if (this.locationDetailsExpanded) {
        const element = document.getElementById('location-details');
        element.scrollIntoView(true);
      }
    }, 200);
  }

  reloadData() {
    this.reload.emit(true);
  }

  isPickupPhase(): boolean {
    return isPickupPhaseStatus(this.status);
  }

  isDropPhase(): boolean {
    return isDropPhase(this.status, this.orderType);
  }

  shouldShowOtpRow(): boolean {
    return this.isPickupPhase() &&
      this.otpString != null &&
      this.otpString.length > 0;
  }

  ngOnDestroy() {
    this.subscriber.unsubscribe();
  }

}
